import { createTheme } from "@mui/material/styles";
import { Plus_Jakarta_Sans } from "next/font/google";
import { Theme } from "@mui/material/styles";

export const plus = Plus_Jakarta_Sans({
  weight: ["300", "400", "500", "600", "700"],
  subsets: ["latin"],
  display: "swap",
  fallback: ["Helvetica", "Arial", "sans-serif"],
});

const baselightTheme = createTheme({
  direction: "ltr",
  palette: {
    primary: {
      main: "#0085db",
      light: "#e5f3fb",
      dark: "#0085db",
    },
    secondary: {
      main: "#707a82",
      light: "#e7ecf0",
      dark: "#707a82",
    },
    success: {
      main: "#4bd08b",
      light: "#dffff3",
      dark: "#4bd08b",
      contrastText: "#ffffff",
    },
    info: {
      main: "#46caeb",
      light: "#e1f5fa",
      dark: "#46caeb",
      contrastText: "#ffffff",
    },
    error: {
      main: "#fb977d",
      light: "#ffede9",
      dark: "#fb977d",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#f8c076",
      light: "#fff6ea",
      dark: "#f8c076",
      contrastText: "#ffffff",
    },
    grey: {
      100: "#F2F6FA",
      200: "#f0f5f9",
      300: "#DFE5EF",
      400: "#7C8FAC",
      500: "#5A6A85",
      600: "#111c2d",
    },
    text: {
      primary: "#111c2d",
      secondary: "#5A6A85",
    },
    action: {
      disabledBackground: "rgba(73,82,88,0.12)",
      hoverOpacity: 0.02,
      hover: "#f6f9fc",
    },
    divider: "#e5eaef",
    background: {
      default: "#F0F5F9",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: plus.style.fontFamily,
    h1: {
      fontWeight: 600,
      fontSize: "2.25rem",
      lineHeight: "2.75rem",
      fontFamily: plus.style.fontFamily,
    },
    h2: {
      fontWeight: 600,
      fontSize: "1.875rem",
      lineHeight: "2.25rem",
      fontFamily: plus.style.fontFamily,
    },
    h3: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: "1.75rem",
      fontFamily: plus.style.fontFamily,
    },
    h4: {
      fontWeight: 600,
      fontSize: "1.3125rem",
      lineHeight: "1.6rem",
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: "1.6rem",
    },
    h6: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "1.2rem",
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
    body1: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "1.334rem",
    },
    body2: {
      fontSize: "0.75rem",
      letterSpacing: "0rem",
      fontWeight: 400,
      lineHeight: "1rem",
    },
    subtitle1: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".MuiPaper-elevation9, .MuiPopover-root .MuiPaper-elevation": {
          boxShadow: "0 7px 30px rgba(17,28,45,0.05) !important",
        },
      },
    },
    // Todas las ventanas redondeadas igual que "Ver tiendas", sin repetir PaperProps en
    // cada Dialog.
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "15px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "18px",
          boxShadow: "0 7px 30px rgba(17,28,45,0.05)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          borderRadius: "25px",
          fontWeight: 600,
        },
        text: {
          padding: "5px 15px",
        },
        // Variante outlined del rediseño: borde celeste suave, texto primario,
        // hover con fondo primary.light.
        outlined: {
          borderColor: "#cfe6f7",
          color: "#0085db",
          "&:hover": {
            borderColor: "#0085db",
            backgroundColor: "#e5f3fb",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "11px",
          "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dfe5ef" },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#0085db" },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#0085db",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: "20px", fontWeight: 600 },
      },
    },
  },
});

export { baselightTheme };
